<template>
  <div>
    <div class="mb-2" v-if="!isDisabled">
      <b-button
        class="ml-1"
        style="fontweight: 600"
        variant="primary"
        size="sm"
        type="submit"
        @click="insertField"
      >
        <i style="font-size: 1rem" class="flaticon2-add-1 pr-0"></i>
      </b-button>
    </div>
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th class="header-color text-center">STT</th>
          <th class="header-color text-center">Tên đợt thanh toán</th>
          <th class="header-color text-center">Số tiền thanh toán</th>
          <th class="header-color text-center" style="white-space: nowrap">
            Đã thu
          </th>
          <th class="header-color text-center" style="white-space: nowrap">
            Ngày bắt đầu
          </th>
          <th class="header-color text-center" style="white-space: nowrap">
            Ngày kết thúc
          </th>
          <!-- <th class="header-color text-center">Mô tả</th> -->
          <!-- <th class="header-color text-center">Chiết khấu</th> -->
          <th></th>
        </tr>
      </thead>
      <tbody
        v-for="(payment, index) in contractData.contractPaymentTerm"
        :key="index"
      >
        <tr class="heighRow">
          <td class="text-center" style="width: 4%">
            <span class="font-weight-bolder">{{ index + 1 }}</span>
          </td>
          <td>
            <b-input
              type="text"
              size="sm"
              class="input-style"
              v-model="payment.name"
              :disabled="isTermLocked(payment)"
            ></b-input>
          </td>
          <td style="width: 16%">
            <b-input
              type="text"
              size="sm"
              class="input-style"
              v-model="payment.totalAmount"
              :disabled="isTermLocked(payment)"
              v-mask="mask"
            ></b-input>
          </td>
          <td
            class="text-center align-middle"
            style="white-space: nowrap; padding-left: 8px; padding-right: 8px"
          >
            <template v-if="isFullyPaid(payment)">
              <b-badge
                variant="success"
                class="d-inline-flex align-items-center"
              >
                <i class="fas fa-check mr-1" style="color: #fff !important"></i>
                <span>Thành công</span>
              </b-badge>
              <div
                class="text-success small mt-1"
                :title="paidForTermDisplay(payment)"
              >
                {{ paidForTermDisplay(payment) }}
              </div>
              <div
                v-if="paymentCodesOfTerm(payment).length"
                class="pt-payment-refs"
              >
                <span
                  v-for="(code, codeIdx) in paymentCodesOfTerm(payment)"
                  :key="`${index}-code-${codeIdx}`"
                  class="pt-payment-ref"
                  :title="code"
                  >{{ code }}</span
                >
              </div>
              <!-- Cập nhật mã tham chiếu / ảnh chứng từ: chuyển vào dropdown thao tác. -->
            </template>
            <template v-else-if="paidForTerm(payment) > 0">
              <span class="text-warning">
                {{ paidForTermDisplay(payment) }}
              </span>
              <div
                v-if="paymentCodesOfTerm(payment).length"
                class="pt-payment-refs"
              >
                <span
                  v-for="(code, codeIdx) in paymentCodesOfTerm(payment)"
                  :key="`${index}-code-${codeIdx}`"
                  class="pt-payment-ref"
                  :title="code"
                  >{{ code }}</span
                >
              </div>
            </template>
            <span v-else class="text-muted">—</span>
          </td>
          <td style="width: 15%">
            <b-input-group>
              <date-picker
                placeholder="Ngày bắt đầu"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="payment.fromDate"
                :disabled="isTermLocked(payment)"
              ></date-picker>
            </b-input-group>
          </td>
          <td style="width: 15%">
            <b-input-group>
              <date-picker
                placeholder="Ngày kết thúc"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="payment.toDate"
                :disabled="isTermLocked(payment)"
              ></date-picker>
            </b-input-group>
          </td>
          <td style="width: 5%">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" no-caret right :disabled="isDisabled">
                <template slot="button-content">
                  <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i>
                </template>
                <!-- <b-dropdown-item @click="addProductGift(productItem)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="fas fa-gift"></i>
                    &nbsp; Thêm quà tặng
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="!getInstallmentInterestZero"
                  @click.prevent="addProductAttach(productItem)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="fas fa-tags"></i>
                    &nbsp; Thêm SP bán kèm
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    onShowPrivateNote(productItem, `popover-note-${index}`)
                  "
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-notepad"></i>
                    &nbsp; Thêm ghi chú
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="!getInstallmentInterestZero"
                  @click="changeProduct(productItem, 'main')"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-add-1"></i>
                    &nbsp; Đổi sản phẩm
                  </span>
                </b-dropdown-item> -->
                <template v-if="contractData.id && payment.id">
                  <!-- Đợt đã đủ tiền (Thành công) → cập nhật thông tin, KHÔNG tạo phiếu mới -->
                  <template v-if="isFullyPaid(payment)">
                    <b-dropdown-item
                      v-for="mp in missingCodePayments(payment)"
                      :key="`dd-code-${mp.id}`"
                      @click="openUpdateCode(mp)"
                    >
                      <span style="color: #3f4254; font-size: 12px">
                        <i
                          style="font-size: 1rem; color: #f64e60"
                          class="fas fa-hashtag"
                        ></i>
                        &nbsp; Cập nhật mã tham chiếu{{
                          amountSuffix(payment, mp)
                        }}
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-for="rp in paymentsOfTerm(payment)"
                      :key="`dd-img-${rp.id}`"
                      @click="openImages(rp)"
                    >
                      <span style="color: #3f4254; font-size: 12px">
                        <i
                          style="font-size: 1rem; color: #3699ff"
                          class="fas fa-image"
                        ></i>
                        &nbsp; Ảnh chứng từ{{
                          rp.images && rp.images.length
                            ? ` (${rp.images.length})`
                            : ''
                        }}{{ amountSuffix(payment, rp) }}
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                  </template>
                  <!-- Đợt chưa đủ tiền → tạo phiếu thu / báo có -->
                  <template v-else>
                    <b-dropdown-item @click="onAddReceipt(payment, 'CASH')">
                      <span style="color: #3f4254; font-size: 12px">
                        <i
                          style="font-size: 1rem; color: #1bc5bd"
                          class="fas fa-money-bill-wave"
                        ></i>
                        &nbsp; Thêm phiếu thu (tiền mặt)
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="onAddReceipt(payment, 'TRANSFER')">
                      <span style="color: #3f4254; font-size: 12px">
                        <i
                          style="font-size: 1rem; color: #3699ff"
                          class="fas fa-university"
                        ></i>
                        &nbsp; Thêm phiếu báo có (chuyển khoản)
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                  </template>
                  <!-- Hủy phiếu thu chưa đối soát (tiền mặt / chuyển khoản chưa mã) -->
                  <template v-if="voidableReceipts(payment).length">
                    <b-dropdown-item
                      v-for="vp in voidableReceipts(payment)"
                      :key="`dd-void-${vp.id}`"
                      @click="confirmVoidReceipt(payment, vp)"
                    >
                      <span style="color: #3f4254; font-size: 12px">
                        <i
                          style="font-size: 1rem; color: #f59e0b"
                          class="fas fa-undo"
                        ></i>
                        &nbsp; Hủy phiếu thu{{ voidReceiptLabel(payment, vp) }}
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                  </template>
                </template>
                <b-dropdown-item
                  @click="showDeleteAlert(index)"
                  :disabled="isTermLocked(payment)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i>
                    &nbsp; Xóa
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th style="text-align: end" colspan="2">Tổng các đợt :</th>
          <td style="text-align: right; padding: 0px 20px; font-weight: 600">
            {{ formattedTotalPrice }}
          </td>
          <td
            class="text-right"
            :style="{
              padding: '0px 12px',
              fontWeight: 600,
              color:
                totalPaid > 0 && totalPaid >= totalAmount
                  ? '#1bc5bd'
                  : '#3f4254',
            }"
          >
            {{ formattedTotalPaid }}
          </td>
          <td colspan="3"></td>
        </tr>
      </tfoot>
    </table>

    <!-- Modal: bổ sung mã tham chiếu cho phiếu đã thu còn thiếu mã -->
    <b-modal
      v-model="codeDialog.show"
      title="Bổ sung mã tham chiếu"
      hide-footer
      no-close-on-backdrop
      size="sm"
    >
      <b-form-group class="mb-2">
        <label class="font-weight-bold mb-1">
          Mã tham chiếu <span class="text-danger">*</span>
        </label>
        <b-form-input
          v-model="codeDialog.code"
          size="sm"
          autofocus
          placeholder="Nhập mã tham chiếu / mã giao dịch"
          :state="codeDialog.error ? false : null"
          @keyup.enter="submitUpdateCode"
        />
        <small v-if="codeDialog.error" class="text-danger">
          {{ codeDialog.error }}
        </small>
      </b-form-group>
      <div class="d-flex justify-content-end mt-3">
        <b-button
          class="mr-2"
          size="sm"
          variant="secondary"
          :disabled="codeDialog.submitting"
          @click="codeDialog.show = false"
        >
          Đóng
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          :disabled="codeDialog.submitting"
          @click="submitUpdateCode"
        >
          Lưu
        </b-button>
      </div>
    </b-modal>

    <!-- Modal: xem / thêm ảnh chứng từ cho 1 phiếu báo có -->
    <b-modal
      v-model="imageDialog.show"
      title="Ảnh chứng từ phiếu thu / báo có"
      hide-footer
      no-close-on-backdrop
      size="lg"
      @hide="onImageDialogHide"
    >
      <div v-if="imageDialog.loading" class="text-center text-muted py-4">
        <b-spinner small class="mr-2"></b-spinner> Đang tải ảnh...
      </div>
      <div v-else>
        <div v-if="imageDialog.items.length" class="pt-img-grid mb-3">
          <div
            v-for="(it, idx) in imageDialog.items"
            :key="idx"
            class="pt-img-thumb"
            title="Bấm để phóng to"
            @click="openLightbox(idx)"
          >
            <img :src="it.preview" alt="payment-image" />
          </div>
        </div>
        <div v-else class="text-muted mb-3">Chưa có ảnh chứng từ.</div>
        <div v-if="!isDisabled">
          <input
            ref="ptImageInput"
            type="file"
            accept="image/*"
            multiple
            class="d-none"
            @change="onUploadMoreImages"
          />
          <b-button
            size="sm"
            variant="outline-primary"
            class="pt-upload-btn"
            :disabled="imageDialog.uploading"
            @click="$refs.ptImageInput.click()"
          >
            <i class="fas fa-camera mr-1"></i>
            {{ imageDialog.uploading ? 'Đang tải...' : 'Tải thêm ảnh' }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <vue-easy-lightbox
      escDisabled
      :visible="lightbox.visible"
      :imgs="lightbox.imgs"
      :index="lightbox.index"
      @hide="lightbox.visible = false"
    />
  </div>
</template>

<script>
// xoa_dau, convertPrice,
import {
  formatDate,
  currencyMask,
  makeToastFaile,
  makeToastSuccess,
  convertPrice,
  unMaskPrice,
} from '../../../utils/common';
import Swal from 'sweetalert2';
import ApiService from '@/core/services/api.service';
import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  components: { VueEasyLightbox },
  props: ['contractData', 'isDisabled'],
  data() {
    return {
      mask: currencyMask,
      // Modal bổ sung mã tham chiếu cho phiếu đã thu còn thiếu mã.
      codeDialog: {
        show: false,
        payment: null,
        code: '',
        submitting: false,
        error: '',
      },
      // Modal xem / thêm ảnh chứng từ cho 1 phiếu (ảnh private → fetch preview blob).
      imageDialog: {
        show: false,
        payment: null,
        items: [], // [{ preview: blobUrl }]
        loading: false,
        uploading: false,
      },
      // Lightbox phóng to ảnh.
      lightbox: { visible: false, imgs: [], index: 0 },

      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
    };
  },
  computed: {
    totalAmount() {
      return (this.contractData.contractPaymentTerm || []).reduce(
        (sum, item) => sum + Number(unMaskPrice(item.totalAmount)),
        0,
      );
    },
    formattedTotalPrice() {
      return convertPrice(this.totalAmount);
    },
    totalPaid() {
      return (this.contractData.contractPaymentTerm || []).reduce(
        (sum, term) => sum + this.paidForTerm(term),
        0,
      );
    },
    formattedTotalPaid() {
      return convertPrice(this.totalPaid);
    },
  },
  methods: {
    formatDate,
    paymentsOfTerm(term) {
      if (!term || !term.id) return [];
      return (this.contractData.payments || []).filter(
        (p) => p.paymentTermId === term.id,
      );
    },
    paidForTerm(term) {
      return this.paymentsOfTerm(term).reduce(
        (sum, p) => sum + Number(p.amount || 0),
        0,
      );
    },
    paidForTermDisplay(term) {
      const list = this.paymentsOfTerm(term);
      if (!list.length) return '—';
      return `${convertPrice(this.paidForTerm(term))} (${list.length} phiếu)`;
    },
    paymentCodesOfTerm(term) {
      return this.paymentsOfTerm(term)
        .map((p) => (p && p.code ? String(p.code).trim() : ''))
        .filter((c) => c.length > 0);
    },
    // Phiếu báo có (TRANSFER) thuộc đợt nhưng còn thiếu mã tham chiếu.
    missingCodePayments(term) {
      return this.paymentsOfTerm(term).filter(
        (p) =>
          p &&
          p.type === 'TRANSFER' &&
          (!p.code || String(p.code).trim() === ''),
      );
    },
    // Mở modal bổ sung mã tham chiếu cho phiếu đã thu còn thiếu mã.
    openUpdateCode(payment) {
      this.codeDialog = {
        show: true,
        payment,
        code: '',
        submitting: false,
        error: '',
      };
    },
    async submitUpdateCode() {
      const d = this.codeDialog;
      const code = (d.code || '').trim();
      if (!code) {
        d.error = 'Vui lòng nhập mã tham chiếu';
        return;
      }
      d.submitting = true;
      d.error = '';
      try {
        await ApiService.patch(`payments/${d.payment.id}/code`, { code });
        d.payment.code = code;
        makeToastSuccess('Cập nhật mã tham chiếu thành công');
        this.codeDialog.show = false;
        this.$emit('fetch-contract');
      } catch (err) {
        d.error =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
          'Cập nhật mã tham chiếu thất bại';
      } finally {
        d.submitting = false;
      }
    },
    // Hậu tố số tiền để phân biệt khi đợt có nhiều hơn 1 phiếu (dùng trong dropdown).
    amountSuffix(term, p) {
      return this.paymentsOfTerm(term).length > 1
        ? ` - ${convertPrice(p.amount)}`
        : '';
    },
    // Tách object path private → { path, fileName } cho endpoint /files/preview.
    splitImagePath(url) {
      const u = String(url || '');
      const i = u.lastIndexOf('/');
      return {
        path: i >= 0 ? u.substring(0, i + 1) : '',
        fileName: i >= 0 ? u.substring(i + 1) : u,
      };
    },
    async openImages(payment) {
      this.onImageDialogHide(); // revoke blob cũ nếu có
      this.imageDialog = {
        show: true,
        payment,
        items: [],
        loading: true,
        uploading: false,
      };
      await this.loadPaymentImages();
    },
    async loadPaymentImages() {
      const payment = this.imageDialog.payment;
      const urls = (payment && payment.images) || [];
      const items = [];
      this.imageDialog.loading = true;
      try {
        for (const url of urls) {
          const { path, fileName } = this.splitImagePath(url);
          try {
            const res = await ApiService.query('files/preview', {
              params: { path, fileName },
              responseType: 'blob',
            });
            items.push({ preview: URL.createObjectURL(res.data) });
          } catch (e) {
            // ảnh lỗi → bỏ qua
          }
        }
        this.imageDialog.items = items;
      } finally {
        this.imageDialog.loading = false;
      }
    },
    async onUploadMoreImages(event) {
      const files = Array.from(
        (event && event.target && event.target.files) || [],
      );
      if (!files.length) return;
      const payment = this.imageDialog.payment;
      this.imageDialog.uploading = true;
      const uploadedUrls = [];
      try {
        for (const file of files) {
          if (!file.type || !file.type.startsWith('image/')) {
            makeToastFaile('Chỉ cho phép tải lên hình ảnh');
            continue;
          }
          const formData = new FormData();
          formData.append('file', file);
          formData.append('folder', 'contracts');
          const res = await ApiService.post('files/upload', formData);
          const body = (res && res.data) || {};
          const inner = body.data || body;
          if (inner && inner.url) uploadedUrls.push(inner.url);
        }
        if (uploadedUrls.length) {
          await ApiService.patch(`payments/${payment.id}/images`, {
            images: uploadedUrls,
          });
          payment.images = [...(payment.images || []), ...uploadedUrls];
          makeToastSuccess('Tải ảnh lên thành công');
          await this.loadPaymentImages();
          this.$emit('fetch-contract');
        }
      } catch (err) {
        makeToastFaile(
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
            'Tải ảnh lên thất bại',
        );
      } finally {
        this.imageDialog.uploading = false;
        if (event && event.target) event.target.value = '';
      }
    },
    openLightbox(idx) {
      this.lightbox = {
        visible: true,
        imgs: this.imageDialog.items.map((it) => it.preview),
        index: idx,
      };
    },
    onImageDialogHide() {
      (this.imageDialog.items || []).forEach(
        (it) => it.preview && URL.revokeObjectURL(it.preview),
      );
      this.imageDialog.items = [];
    },
    isFullyPaid(term) {
      const paid = this.paidForTerm(term);
      return paid > 0 && paid >= Number(unMaskPrice(term.totalAmount));
    },
    // Phiếu chuyển khoản ĐÃ ĐỐI SOÁT ⟺ type TRANSFER và đã nhập mã tham chiếu.
    // Dùng để xác định phiếu nào KHÔNG được hủy (xem voidableReceipts).
    isReconciledTransfer(p) {
      return (
        !!p && p.type === 'TRANSFER' && !!(p.code && String(p.code).trim())
      );
    },
    // Đợt đã có phiếu thu (hoặc HĐ read-only) → khóa sửa tên/ngày/SỐ TIỀN/xóa đợt.
    // Muốn đổi số tiền: phải HỦY phiếu thu trước → đợt về "chưa thu" → ô mở khóa.
    isTermLocked(term) {
      return this.isDisabled || this.paidForTerm(term) > 0;
    },
    onAddReceipt(term, paymentType) {
      // Gợi ý số tiền = số còn lại của đợt (tổng đợt − đã thu), tối thiểu 0.
      const remaining =
        Number(unMaskPrice(term.totalAmount)) - this.paidForTerm(term);
      this.$emit('add-receipt', {
        term,
        paymentType,
        suggestedAmount: remaining > 0 ? remaining : 0,
      });
    },
    // Chỉ cho hủy phiếu khi HĐ chưa qua bước phân bổ xe (allocated trở đi).
    // Khớp VOIDABLE_CONTRACT_STATUSES ở backend. Status rỗng (data cũ) → vẫn hiện, BE chặn nếu cần.
    voidAllowedByStatus() {
      const allowed = [
        'pendingDeposit',
        'pendingSignature',
        'signed',
        'deposited',
      ];
      const s = this.contractData && this.contractData.status;
      return !s || allowed.includes(s);
    },
    // Phiếu CÓ THỂ hủy: amount != 0 và CHƯA đối soát (tiền mặt hoặc chuyển khoản chưa mã).
    // Chuyển khoản đã có mã (đã đối soát) → không cho hủy (BE cũng chặn).
    voidableReceipts(term) {
      if (!this.voidAllowedByStatus()) return [];
      return this.paymentsOfTerm(term).filter(
        (p) => Number(p.amount || 0) !== 0 && !this.isReconciledTransfer(p),
      );
    },
    voidReceiptLabel(term, p) {
      const kind = p.type === 'TRANSFER' ? 'chuyển khoản' : 'tiền mặt';
      return ` (${kind} · ${convertPrice(p.amount)})`;
    },
    // Hủy 1 phiếu thu: soft-delete phiếu + đảo bút toán đối ứng (BE xử lý trong 1 transaction).
    async confirmVoidReceipt(term, p) {
      const kind = p.type === 'TRANSFER' ? 'chuyển khoản' : 'tiền mặt';
      const result = await Swal.fire({
        title: 'Hủy phiếu thu?',
        html: `Phiếu thu <b>${kind} · ${convertPrice(
          p.amount,
        )}</b> sẽ bị hủy và đảo bút toán tương ứng.<br/>Hành động này không thể hoàn tác.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Hủy phiếu',
        cancelButtonText: '<span style="color:#464E5F">Đóng</span>',
        reverseButtons: true,
      });
      if (!result.isConfirmed) return;
      try {
        await ApiService.delete(`contract/payment/${p.id}`);
        makeToastSuccess('Đã hủy phiếu thu');
        this.$emit('fetch-contract');
      } catch (err) {
        makeToastFaile(
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
            'Hủy phiếu thu thất bại',
        );
      }
    },
    async showDeleteAlert(index) {
      const text = `Bạn muốn xoá điều khoản thanh toán này ra khỏi danh sách`;
      const alert = await this.showWarningAlert(text);
      if (alert.isConfirmed) {
        const countChildsItem = this.contractData.contractPaymentTerm.length;
        this.contractData.contractPaymentTerm.splice(
          index,
          countChildsItem + 1,
        );
      }

      //   if (alert.isConfirmed) {
      //     const index = this.getIndexContractDetail(product.id);

      //     if (index > -1) {
      //       const countChildsItem = this.contractData.contractPaymentTerm.length;
      //       this.contractData.contractPaymentTerm.splice(
      //         index,
      //         countChildsItem + 1,
      //       );
      //       this.numberedOrderItems();
      //     }
      //   }
    },
    showWarningAlert: function (text) {
      return Swal.fire({
        title: 'Xoá điều khoản chuyển khoản!',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Đồng ý',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
    },
    getIndexContractPaymentTerm(id) {
      const index = this.contractData.contractPaymentTerm.findIndex(
        (item) => item.id === id,
      );
      if (index < 0) {
        makeToastFaile(`Không tìm thấy ${id} trong danh sách`);
        return;
      }
      return index;
    },
    insertField() {
      if (this.contractData.contractPaymentTerm.length > 10) {
        makeToastFaile('Không được tạo quá 10 điều khoản thanh toán');
        return;
      }
      const item = {
        name: null,
        totalAmount: 0,
        fromDate: null,
        toDate: null,
      };
      this.contractData.contractPaymentTerm.push(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.pt-payment-refs {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.pt-payment-ref {
  display: block;
  font-family: 'SF Mono', Menlo, Consolas, monospace;
  font-variant-numeric: tabular-nums;
  font-size: 11px;
  color: #64748b;
  line-height: 1.3;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

// Nút tải thêm ảnh trong modal — icon kế thừa màu (frontend-styling rule #1).
.pt-upload-btn {
  font-size: 11px;
  padding: 3px 10px;
  border-radius: 100px;
  white-space: nowrap;
  i {
    font-size: 10px;
    color: inherit !important;
  }
}
// Lưới thumbnail ảnh trong modal.
.pt-img-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.pt-img-thumb {
  width: 110px;
  height: 110px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.15s ease;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &:hover {
    border-color: #3699ff;
  }
}
</style>
